import { applyMiddleware, compose, createStore } from "redux";
import reduceReducers from "reduce-reducers";
import thunk from "redux-thunk";
import { initialState } from "./initialState";

import { errorReducer, loadingReducer, paymentSkipReducer } from "./basic";

import activeStepReducer from "./activeStep";
import addressReducer from "./address";
import coRenterReducer from "./coRenter";
import dealerReducer from "./dealer";
import idReducer from "./id";
import paymentReducer from "./payment";
import remoteReducer from "./remote";
import renterReducer from "./renter";
import salespersonReducer from "./salesperson";
import systemsReducer from "./systems";
import termReudcer from "./term";
import contractImagesReducer from "./contractImages";

const rootReducer = reduceReducers(
  initialState,
  activeStepReducer,
  addressReducer,
  coRenterReducer,
  dealerReducer,
  errorReducer,
  idReducer,
  loadingReducer,
  paymentReducer,
  paymentSkipReducer,
  remoteReducer,
  renterReducer,
  systemsReducer,
  salespersonReducer,
  termReudcer,
  contractImagesReducer
);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
